// src/composables/useStopwatch.js
import { reactive, toRefs, onUnmounted } from 'vue'

export function useStopwatch(initialSeconds = 0, autoStart = false) {
  const state = reactive({
    seconds: 0,
    minutes: 0,
    hours: 0,
    totalSeconds: initialSeconds,
    isRunning: false,
    _interval: null,
    _startTime: null,      // timestamp when started
    _pausedAt: null        // timestamp when paused
  })

  const syncTime = () => {
    state.hours = Math.floor(state.totalSeconds / 3600)
    state.minutes = Math.floor((state.totalSeconds % 3600) / 60)
    state.seconds = state.totalSeconds % 60
  }

  const tick = () => {
    const now = Date.now()
    state.totalSeconds = Math.floor(
      (now - state._startTime) / 1000
    )
    syncTime()
  }

  const start = () => {
    if (state.isRunning) return

    const now = Date.now()

    if (state._pausedAt) {
      // resume
      state._startTime += (now - state._pausedAt)
      state._pausedAt = null
    } else {
      // fresh start
      state._startTime = now - state.totalSeconds * 1000
    }

    state.isRunning = true
    state._interval = setInterval(tick, 1000)
  }

  const pause = () => {
    if (!state.isRunning) return
    state.isRunning = false
    state._pausedAt = Date.now()
    clearInterval(state._interval)
    state._interval = null
  }

  const reset = (seconds = 0) => {
    pause()
    state.totalSeconds = seconds
    state._startTime = null
    state._pausedAt = null
    syncTime()
  }

  syncTime()
  if (autoStart) start()

  onUnmounted(() => {
    clearInterval(state._interval)
  })

  return {
    ...toRefs(state),
    start,
    pause,
    reset
  }
}
